import { TFormHeadingData, TFormNavigationFieldType, TFormNavigationItemDataFieldType, TFormNavigationStepType, TFormPageNavigationProps } from "../types/formPageNavigation.types";

export class FormPageNavigationModel {
    private readonly fields?: TFormNavigationFieldType;
    private readonly ItemDatafields?: TFormNavigationItemDataFieldType;
    private readonly formHeadingData?: TFormHeadingData;

    constructor(props: TFormPageNavigationProps) {
        this.fields = props?.fields;
        this.ItemDatafields = this.fields?.itemData?.fields || null;
        this.formHeadingData = this.ItemDatafields?.FormHeadingData;
    }

    get steps(): TFormNavigationStepType[] {
        return this.ItemDatafields?.FormPageNavigation || [];
    }

    get hasSteps(): boolean {
        return !!this.steps.length;
    }

    get isUnreleased(): boolean {
        return !!this.fields?.isComponentUnreleased;
    }

    get title(): string {
        return this.formHeadingData?.title || '';
    }

    get eyebrow(): string {
        return this.formHeadingData?.eyebrow || '';
    }

    get subtitle(): string {
        return this.formHeadingData?.subtitle || '';
    }
}
